import { React, useState } from "react";
import { Link } from "react-router-dom";
import Login from "../login";
import Register from "../register";
import { useUserStore } from "../../../store/useUserStore";
import { useCartStore } from "../../../store/useCartStore";
function Buttons() {
  const user = useUserStore((state) => state.user);
  // const shopping = useCartStore((state) => state.shopping);
  const { shopping, cart } = useCartStore((state) => state);

  const [userMenu, setUserMenu] = useState(false);
  const [modal, setModal] = useState(false);
  const [popupLogin, setPopupLogin] = useState(false);
  const [popupRegister, setPopupRegister] = useState(false);

  // const handleUserMenu = () => {
  //     if (userMenu) {
  //         setUserMenu(false);
  //     } else {
  //         setUserMenu(true);
  //     }
  // }

  //Login handler
  const handleModalLogin = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }

    if (popupLogin) {
      setPopupLogin(false);
    } else {
      setPopupLogin(true);
    }
  };

  //Register Handler
  const handleOTP = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }

    // if(popupOtp){
    //     setPopupOtp(false);
    // }else{
    //     setPopupOtp(true);
    // }
  };

  //Modal click handler
  function modalClick() {
    setModal(false);
    setPopupLogin(false);
    document.querySelector(".loginModal").classList.remove("active");
    document.querySelector(".otp_modal").classList.remove("active");
    document.querySelector(".register_modal").classList.remove("active");
    // setPopupOtp(false);
  }

  return (
    <>
      <div className="col-lg-4 col-3">
        <div className="buttons">
          <Link to="cart" className="d-none d-lg-block">
            <span>{shopping.total_items || 0}</span>
            <i className="fab fa-opencart"></i>
          </Link>
          {user.auth ? (
            <Link
              to="profile"
              className="d-flex align-items-center bg-dark px-2 py-1 rounded text-warning"
              style={{ fontSize: "10px" }}
            >
              <i
                className="fas fa-user"
                style={{
                  marginLeft: "5px",
                  marginRight: "5px",
                }}
              ></i>
              <p className="showBtnText" style={{ margin: "0" }}>
                {user.name}
              </p>
            </Link>
          ) : (
            <a href="#!" onClick={handleModalLogin}>
              <i className="fas fa-user"></i>
            </a>
          )}

          <Link
            to="reserve "
            className="d-flex align-items-center bg-dark px-2 py-1 rounded text-white"
          >
            <i
              className="far fa-calendar-alt"
              style={{
                marginLeft: "5px",
                marginRight: "5px",
              }}
            ></i>
            <p className="showBtnText" style={{ margin: "0" }}>
              رزرو میز
            </p>
          </Link>
        </div>
      </div>
      <div
        className={modal ? "modal active" : "modal"}
        onClick={modalClick}
      ></div>
      <Login showPop={popupLogin} />
    </>
  );
}

export default Buttons;
{
  /* <a href="https://t.me/baghban_restauran" target="_blank" className="d-none d-lg-block">
                    <i className="fab fa-telegram"></i>
                </a>
                <a href="https://api.whatsapp.com/send?phone=989152002090" target="_blank" className="d-none d-lg-block">
                    <i className="fab fa-whatsapp"></i>
                </a>
                <a href="https://instagram.com/baghbanrestaurant?igshid=YmMyMTA2M2Y=" target="_blank" className="d-none d-lg-block">
                    <i className="fab fa-instagram"></i>
                </a> */
}
